import {base64UrlDecode} from '@/utils/portuna';
import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';
import dateHelper from '../utils/portuna/dateHelper';
import {timeTrackerMeta} from './time-tracker';

const AbsenceList     = () => import('../views/absences/AbsenceList.vue');
const AbsenceCalendar = () => import('../views/absences/AbsenceCalendar.vue');

let absences: RouteRecordRaw[] = [
    {
        path: '/employee/absences',
        redirect: {name: 'absences-list'},
        meta: timeTrackerMeta,
    },
    {
        path: '/employee/absences/list',
        name: 'absences-list',
        component: AbsenceList,
        meta: timeTrackerMeta,
    },
    {
        name: 'absence-calendar',
        path: '/employee/employee/absence-calendar/:year(\\d{4})?/:filter?',
        component: AbsenceCalendar,
        meta: timeTrackerMeta,
        props(route: RouteLocationStringParam)
        {
            return {
                year: route.params.year ? parseInt(route.params.year) : dateHelper('Y'),
                filter: route.params.filter ? JSON.parse(base64UrlDecode(route.params.filter)) : {},
            };
        },
    },
];

export default absences;